export const nameSurnameValidator = /^[a-zA-Z-ąćęłńóśźżĄĆĘŁŃÓŚŹŻ ]+$/;
export const peselValidator = /^(\d{11})$/;
export const peselValidatorOptional = /^(___________)|(\d{11})$/;
export const postalCodePolandValidator = /^((\d{2})-(\d{3}))$/;
export const postalCodePolandValidatorOptional = /^(__-___)|((\d{2})-(\d{3}))$/;
export const postalCodeGenericValidatorOptional = /^[a-zA-Z0-9 -]{3,10}$/;
export const timeValidator = /^(\d{2}):(\d{2})$/;
export const regonValidator = /(^\d{9}$)|(^\d{14}$)/;
export const ocValidatorOptional = /^[a-zA-Z0-9]{0,30}$/;
export const ocValidator = /^[a-zA-Z0-9\/-]{0,30}$/;
export const startBracket = /(\[)/g;
export const endBracket = /(\])/g;
export const vinValidator = /^(?:(?![ioqIOQ])[a-zA-Z0-9]){17}$/;
export const yearValidator = /^\d{4}$/;
export const emailValidatorRegex = /^[^ąćęłńóśźżĄĆĘŁŃÓŚŹŻ]+$/;

//Ewentualne reklamacje na ten RegEx do GPT - teoretycznie ma to działać tak :
/*
DOBRE
19/01/2025
01/12/1900
31/12/2099
01/01/2100
2023
1900
2100

ZŁE
19/13/2023   (zły miesiąc)
32/01/2023   (zły dzień)
01-01-2023   (zły separator)
01012023     (brak slashy)
20231        (za dużo cyfr)
123          (za mało cyfr)
abcd
2023/01
2999         (poza zakresem)
18/01/1899   (poza zakresem)
*/
export const dateValidator =
  /^(?:((?:0[1-9]|[12][0-9]|3[01])\/(?:0[1-9]|1[0-2])\/(?:19\d{2}|20\d{2}|2100))|(?:19\d{2}|20\d{2}|2100))$/;
